<!-- グローバルナビプレビュー用 -->
<template>
  <nav>
    <ul>
      <li v-for="item in displayedItems" :key="item.categoryId">
        <a>
          {{ item.itemName }}
          <span
            v-if="item.children && item.children.length > 0"
            class="blt1"
          ></span>
        </a>
        <div v-if="item.children && item.children.length > 0">
          <ul>
            <li v-for="child in item.children" :key="child.categoryId">
              <a>
                {{ child.itemName }}
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li v-if="otherItems.length > 0">
        <a href="#" class="hasChildren">
          その他
          <span class="blt1"></span>
        </a>
        <div>
          <ul>
            <li v-for="other in otherItems" :key="other.categoryId">
              <a>
                {{ other.itemName }}
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";

type List = {
  categoryId: string;
  parentId: string | null;
  itemName: string;
  itemUrl: string;
};

export default defineComponent({
  name: "GlobalNavikanriComponent",
  props: {
    previewData: {
      type: Object as PropType<List[]>,
      required: true,
    },
  },
  setup(props) {
    const items = computed(() => props.previewData);
    const maxItems = 5;

    const rootItems = computed(() => {
      return Array.isArray(items.value)
        ? items.value.filter((item) => item.parentId === "")
        : [];
    });

    const displayedItems = computed(() => {
      return rootItems.value.slice(0, maxItems).map((item) => {
        const children = items.value.filter(
          (child) => child.parentId === item.categoryId
        );
        return { ...item, children };
      });
    });

    const otherItems = computed(() => {
      if (rootItems.value.length <= maxItems) return [];
      return rootItems.value.slice(maxItems).map((item) => {
        const children = items.value.filter(
          (child) => child.parentId === item.categoryId
        );
        return { ...item, children };
      });
    });

    return { items, displayedItems, otherItems };
  },
});
</script>
<style>
.hasChildren {
  position: relative;
}
</style>
